// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { FrontendProject } from "../schema";

export function serialize_FrontendProject_internal(value: FrontendProject): unknown {
  return ((value: "VUE" | "DESIGN"): unknown => {
    return value;
  })(value);
}
export function serialize_FrontendProject(obj: FrontendProject): string {
  return renderJsonWithNumbersAsBigint(serialize_FrontendProject_internal(obj));
}
export function deserialize_FrontendProject_internal(value: unknown): ParserResult<FrontendProject> {
  return ((value: unknown): ParserResult<"VUE" | "DESIGN"> => {
    if (typeof value !== "string") {
      return { success: false, reason: `[#/components/schemas/FrontendProject]: '${value}' expected to be of type string.` };
    }
    switch (value) {
      case "VUE":
        return { success: true, value: "VUE" };
      case "DESIGN":
        return { success: true, value: "DESIGN" };
      default:
        return { success: false, reason: `[#/components/schemas/FrontendProject]: '${value}' expected to be enum, one of 'VUE, DESIGN'.` };
    }
  })(value);
}
export function deserialize_FrontendProject(str: string): ParserResult<FrontendProject> {
  return deserialize_FrontendProject_internal(parseJsonWithNumbersAsBigint(str));
}
